var nuanceData = {};

var contextData = {
    'Brand': 'Churchill',
    'InvocationPoint': 'Forms_MTA',
    'CustomerID': 'N/A', // Unused at present.
    'Product': 'Car',
    'ProductCertainty': 'High' // High/Medium/Low (or N/A)
}

nuanceData.contextData = JSON.stringify(contextData);
